<app-loader *ngIf="loaderIcon | async"></app-loader>
<div class="container-fluid ">
    <div class="row g-3" *ngIf="!payByBooth">
        <!-- Left Panel -->
        <div class="col-lg-4">
            <div class="card shadow p-3 mb-3">
                <div class="d-flex align-items-center mb-3">

                    @if(vendorDashboardInfo?.VendorProfile == "")
                    {
                    <div class="profile-placeholder me-3">
                        <img src="./assets/images/NoPhoto-Dashboard.svg">
                    </div>

                    }@else{
                    <div class="profile-placeholder-image me-3">
                        <img [src]="vendorDashboardInfo?.VendorProfile +`?timestamp=${this.timestamp}`">
                    </div>
                    }
                    <div>
                        <h5 class="mb-1">{{vendorDashboardInfo?.VendorName}}</h5>
                        <span class="text-muted">ID : {{vendorDashboardInfo?.MarketVendorId}}</span>
                    </div>
                </div>
                <div class="vendor_detail">
                    <ul class="list-unstyled">
                        <li>
                            <label i18n>Telephone</label>
                            <p>{{vendorDashboardInfo?.TelePhone | phoneFormat}}</p>
                        </li>
                        <li>
                            <label i18n>Cellphone</label>
                            <p>{{vendorDashboardInfo?.CellPhone | phoneFormat}}</p>
                        </li>
                        <li>
                            <label i18n>Workphone</label>
                            <p>{{vendorDashboardInfo?.WorkPhone | phoneFormat}}</p>
                        </li>
                        <li>
                            <label i18n>Email</label>
                            <p>{{vendorDashboardInfo?.Email}}</p>
                        </li>
                        <li>
                            <label i18n>City</label>
                            <p>{{vendorDashboardInfo?.City}}</p>
                        </li>
                        <li>
                            <label i18n>State</label>
                            <p>{{vendorDashboardInfo?.State}}</p>
                        </li>
                        <li>
                            <label i18n>Vendor Since</label>
                            <p>{{vendorDashboardInfo?.VendorSince | date:'MM/dd/YYYY'}}</p>
                        </li>
                    </ul>

                </div>
            </div>

            <!-- Comments Box -->
            <div class="card shadow p-3">
                <label class="form-label fw-semibold">Comments</label>
                <textarea class="form-control mb-2" [(ngModel)]="VendorComment" rows="4"
                    placeholder="Add a Comment"></textarea>
                <button class="btn btn-dark" style="width: 100px"
                    [disabled]="vendorDashboardInfo?.Comment == VendorComment"
                    (click)="updateVendorComment()">Save</button>
            </div>
        </div>

        <!-- Right Panel -->
        <div class="col-lg-8">
            <!-- Rental Status Grid -->
            <div class="card shadow p-3 mb-3">
                <h6 class="fw-semibold mb-3">Rental Status</h6>
                <ejs-grid #gridRentalStatus [dataSource]="rentalData" [allowPaging]="false">
                    <e-columns>
                        <e-column field="LastTransactionDate" headerText="Last Transaction Date" width="180"></e-column>
                        <e-column field="sales" headerText="Sales from Last Payout" textAlign="Right"
                            width="200"></e-column>
                        <e-column field="BalanceDue" headerText="Rental Balance Due" textAlign="Right" width="160">
                            <ng-template #template let-data>
                                {{ data.BalanceDue >= 0 ?
                                (data.BalanceDue | currency) :
                                '('+(data.BalanceDue * -1 | currency)+')'
                                }}
                            </ng-template>
                        </e-column>
                        <e-column headerText="Action" width="140" textAlign="Center">
                            <ng-template #template let-data>
                                <button class="btn btn-success btn-sm" (click)="openPaymentPage()">Pay</button>
                            </ng-template>
                        </e-column>
                    </e-columns>
                </ejs-grid>
            </div>

            <!-- Rental Booths -->
            <div class="d-flex card shadow p-3 mb-3">
                <div class="row">
                    <div class="col-md-6 col-lg-5 text-start mt-2">
                        <div class="pb-3">
                            <div class="custom-toggle-container form-check">
                                <input type="checkbox" id="webInquiryToggle" class="custom-toggle"
                                    [(ngModel)]="IsWebInquiryEnabled" (click)="onWebInquiryToggleClick($event)" />
                                <label for="webInquiryToggle" class="custom-toggle-label">
                                    <span class="custom-toggle-text on-text">ON</span>
                                    <span class="custom-toggle-text off-text">OFF</span>
                                </label>
                                <span class="ms-2 fw-semibold text-dark">Enable Web Inquiry</span>
                            </div>
                        </div>

                        <div class="p-1">
                            <div class="form-check form-check-inline vactv-custom-checkbox">
                                <input class="form-check-input" type="checkbox" id="ActiveStatus"
                                    (click)="onToggleActiveStatusClick($event)" [(ngModel)]="IsVendorInActive">
                                <label class="form-check-label fw-semibold text-dark" for="ActiveStatus">
                                    Active
                                </label>
                            </div>

                            <div class="form-check form-check-inline vactv-custom-checkbox">
                                <input class="form-check-input" type="checkbox" id="AutoDeRent"
                                    (click)="ToggleAutoDeRent()" [(ngModel)]="AutoDeductRent">
                                <label class="form-check-label fw-semibold text-dark" for="AutoDeRent">
                                    Auto Deduct Rent
                                </label>
                            </div>
                        </div>

                    </div>
                    <div class="col-md-6 col-lg-7 text-start mt-2">

                        <div class="row p-1">
                            <div class="col-8">
                                <div class="form-check vactv-custom-checkbox">
                                    <input class="form-check-input" type="checkbox" id="FlatCommPos"
                                        (click)="TogglFlatCommPos()" [(ngModel)]="ApplyFlatComPos">
                                    <label class="form-check-label fw-semibold text-dark" for="FlatCommPos">
                                        Apply Flat Commission on POS (%)
                                    </label>
                                </div>
                            </div>

                            <div class="col-4">
                                <input type="text" class="form-control" style="background-color: #e8e9e9;"
                                    [readonly]="true" [(ngModel)]="FlatComPos" (click)="updateFlatCommPos()">
                            </div>

                        </div>
                        <div class="row p-1">
                            <div class="col-8">
                                <div class="form-check vactv-custom-checkbox">
                                    <input class="form-check-input" type="checkbox" id="ConsComm"
                                        (click)="ToggleConsComm()" [(ngModel)]="EnableConsignmentCom">
                                    <label class="form-check-label fw-semibold text-dark" for="ConsComm">
                                        Consignment Commission (%)
                                    </label>
                                </div>
                            </div>

                            <div class="col-4">
                                <input type="text" class="form-control" style="background-color: #e8e9e9;"
                                    [readonly]="true" [(ngModel)]="ConsignmentCom" (click)="updateConsignmentCom()">
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <!-- Notes Section -->
            <div class="card shadow p-3">
                <h6 class="fw-semibold mb-3">Notes</h6>
                <ejs-grid [dataSource]="notesData" height="150" [allowPaging]="false">
                    <e-columns>
                        <e-column field="CreatedOn" headerText="Created Date" width="160"></e-column>
                        <e-column field="Notes" headerText="Notes" width="300"></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
        </div>
    </div>

    <div *ngIf="payByBooth">
        <app-rental-pay-bybooth [Dues]="Dues" [vendorId]="vendorId" (closePayByBooth)="closePayByBooth($event)"
            (paymentCompleted)="HandleReceipts($event)" [PriorBalance]="priorBalance"
            (cancelPayByBooth)="cancelPayByBooth($event)"></app-rental-pay-bybooth>
    </div>
</div>

<!-- Receipt Modal -->
<div class="modal fade" id="printReceiptPopup" tabindex="-1" aria-labelledby="printReceiptModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl modal-fullSize">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="printReceiptModalLabel">Preview</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div class="modal-body">
                <!-- Loading Spinner -->
                <div class="text-center py-5" *ngIf="loading; else pdfViewReceipt">
                    <div class="spinner-border text-primary" role="status"></div>
                    <p class="mt-2 text-muted">Loading receipt...</p>
                </div>

                <!-- PDF View -->
                <ng-template #pdfViewReceipt>
                    <iframe *ngIf="receiptUrl" [src]="receiptUrl" width="100%" height="500px" frameborder="0"></iframe>
                </ng-template>
            </div>
            <div class="modal-footer">
                <button class="btn btn-orange" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>